import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import GridWrapper from '@/components/ui/GridWrapper';
import { useAnalytics } from '@/hooks/analytics';

import messages from './messages';
import { BodyText, ButtonWithMargin, ContentContainer, Heading, Wrapper } from './styles';
import { IneligibleOverlayProps } from './types';

const IneligibleOverlay = ({ adminName }: IneligibleOverlayProps) => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	useEffect(
		() => {
			logEvent({
				eventName: 'Family Plan Landing : Ineligible Overlay : Shown',
			});
		}, // TODO [WEB-1595]: Fix this exhaustive-deps issue
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	return (
		<Wrapper>
			<GridWrapper columns={4} id={MAIN_CONTENT_ID}>
				<ContentContainer>
					<Heading>{formatMessage(messages.heading)}</Heading>
					<BodyText>
						{formatMessage(messages.copy, {
							name: adminName,
						})}
					</BodyText>
					<ButtonWithMargin fullWidth href="/signup" backgroundColor="gradientTabBlue" textColor="white">
						{formatMessage(messages.createAccountCta)}
					</ButtonWithMargin>
					<Button fullWidth href="/" backgroundColor="white" textColor="gray8" borderColor="gray6">
						{formatMessage(messages.backToCalmCta)}
					</Button>
				</ContentContainer>
			</GridWrapper>
		</Wrapper>
	);
};

export default IneligibleOverlay;
